import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo, useCallback } from "react";
import moment from "moment/moment";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
  Dropdown,
} from "react-bootstrap";
import { 
  getEmployeePhoto,
  getEmployeeEdit, 
  getCompanyLists, 
  resetForm,
  dismissEmployee,
  dismissUser,
  updateForm,
  addUsername,
  addUser, 
  updateUser,
  addEmployee,
  addLeaveProrated,
  updateProrated,
  updatePhoto,
  uploadEmployeePhoto,
  replaceEmployeePhoto,
  getAEmployee,
  postsearchText,
  getMedicalbenefitLeaveSummaryEmployeeYear,
  getLeaveSummaryEmployeeYear, 
  getSickleaveSummaryEmployeeYear, 
} from "../../3.Store/EmployeeSlice";
import { addLeaveAwards, updateList, getLeaveAwardedThisYear } from "../../3.Store/LeaveAwardsSlice";
import { Authentication, Gender, WorkingSchedule } from "../../2.Commons/DropdownOption";
import { getEntitle } from "../../3.Store/LeaveEntitlementSlice";
import { getSite } from "../../3.Store/SiteSlice";
import { getUserModule, updateUserAccessModules, updateEmployeeModules } from "../../3.Store/UserAccessSlice";
import { ThreeDots } from 'react-loader-spinner';
import { openEditor } from "react-profile";
import "react-profile/themes/default";
import defaultPhoto from "../../2.Commons/defaultPhoto.jpg";
import './Employee.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getALeaveProratesByID, updateEntitle, updateLeaveProrates } from "../../3.Store/LeaveProratedSlice";

const EmployeeForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [showResetPwd, setShowResetPwd] = useState(false);
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [repeatNewPassword, setRepeatNewPassword] = useState("");
  const [passwordGenerated, setPasswordGenerated] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showUploadButton, setShowUploadButton] = useState(false);
  const [showOptionDialog, setShowOptionDialog] = useState(false);
  const [showProrated, setShowProrated] = useState(false);
  const [originalPhoto, setOriginalPhoto] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const loading = useSelector(state => state.EmployeeSlice.loading);
  const loading2 = useSelector(state => state.LeaveAwardsSlice.loading);
  const [loading3, setLoading3] = useState(false);
  const photo = useSelector((state) => state.EmployeeSlice.photo);
  const employee = useSelector((state) => state.EmployeeSlice.employeeDetail);
  const user = useSelector((state) => state.EmployeeSlice.user);
  const companyLists = useSelector((state) => state.EmployeeSlice.company);
  const awardList = useSelector(state => state.LeaveAwardsSlice.awardList);
  const awarded = useSelector((state) => state.LeaveAwardsSlice.awarded);
  const leaveProrated = useSelector((state) => state.EmployeeSlice.leaveProrated);
  const entitle = useSelector((state) => state.LeaveProratedSlice.entitle);
  const employees = useSelector(state => state.EmployeeSlice.employees);
  const summary = useSelector((state) => state.EmployeeSlice.summaries);
  const sickLeaveSummaries = useSelector((state) => state.EmployeeSlice.sickLeaveSummaries);
  const medicalBenefitSummaries = useSelector((state) => state.EmployeeSlice.medicalBenefitSummaries);
  const employeeModules = useSelector(state => state.UserAccessSlice.employeeModules) || [];
  const proratesList = useSelector(state => state.LeaveProratedSlice.proratesList) || {};
  const siteLists = useSelector(state => state.SiteSlice.sites);
  const { 
    fullname,
    username,
    sid,
    gender,
    date_joined,
    date_left,
    email,
    company,
    working_schedule,
    employee_category,
    service_length,
    supervisor,
    site,
    status
  } = employee || {};
  const { password, authentication_type } = user;
  const { annual, maternity, medical, sick } = awardList;
  const { sick_entitle, annual_entitle, medical_entitle } = entitle;
  const { 
    prorated_leave_awarded,
    prorated_sickleave_awarded,
    new_leave_balance,
    prorated_medicalbenefit_awarded,
  } = leaveProrated;
  let oldPhotoUrl = "";

  const leaveEntitlements = useSelector((state) => state.LeaveEntitlementSlice.entitles);

  //Check current user id, check if current form is Jennifer or Irene
  const current_user = JSON.parse(localStorage.getItem("current_user"));
  const current_userId = current_user?.id;

  const HR = ["a1d97c4a-0020-af94-3164-b99066091610", "a3e96026-2a9c-e4a4-3d2f-744b70a0a260"];
  const isIdInHR = HR.includes(id);
  const isCurrentUserInHR = HR.includes(current_userId);

  //Impersonate Role
  const roles = JSON.parse(localStorage.getItem("roles"));
  const impersonate_role = roles.includes("HR-IMPERSONATE");

  // Derive employee categories from leave entitlements
  const dynamicCategories = useMemo(() => {
    const map = new Map();
    leaveEntitlements.forEach(e => {
      if (e.employee_catagory && !map.has(e.employee_catagory.id)) {
        map.set(e.employee_catagory.id, {
          id: e.employee_catagory.id,
          label: e.employee_catagory.description,
          value: e.employee_catagory.id,
        });
      }
    });
    return Array.from(map.values());
  }, [leaveEntitlements]);

  // Derive service lengths from leave entitlements
  const dynamicServiceLengths = useMemo(() => {
    const map = new Map();
    leaveEntitlements.forEach(e => {
      if (e.service_length && !map.has(e.service_length.id)) {
        map.set(e.service_length.id, {
          id: e.service_length.id,
          label: e.service_length.description,
          value: e.service_length.id,
        });
      }
    });
    return Array.from(map.values());
  }, [leaveEntitlements]);

  // Derive category-to-service-length mapping from leave entitlements
  const dynamicCategoryServiceMap = useMemo(() => {
    const map = {};
    leaveEntitlements.forEach(e => {
      if (e.employee_catagory && e.service_length) {
        const catId = e.employee_catagory.id;
        if (!map[catId]) map[catId] = [];
        if (!map[catId].includes(e.service_length.id)) {
          map[catId].push(e.service_length.id);
        }
      }
    });
    return map;
  }, [leaveEntitlements]);

  // Look up leave values from entitlements by combined ID (category + service length, e.g. "MP")
  const getLeaveValues = useCallback((categoryId, serviceLengthId) => {
    const combinedId = categoryId + serviceLengthId;
    console.log("Looking up leave values for ID:", serviceLengthId);
    const entitlement = leaveEntitlements.find(e => e.id === combinedId);
    console.log(entitlement);
    if (entitlement) {
      return {
        annual: entitlement.annual,
        hospitalization: entitlement.hospitalization,
        maternity: entitlement.maternity,
        medical: entitlement.medical,
        sick: entitlement.sick,
      };
    }
    return null;
  }, [leaveEntitlements]);

  const filteredServiceLengths = dynamicServiceLengths.filter(sl =>
    (dynamicCategoryServiceMap[employee_category?.id] || []).includes(sl.id)
  );

  const generatePassword = () => {
    const charset = "abcdefghjkmnpqrstuvwxyzABCDEFGHJKMNPQRSTUVWXYZ23456789";
    let autoPassword = "";

    for (let i = 0; i < 11; i++) { // Assuming default password length is 12
      autoPassword += charset.charAt(Math.floor(Math.random() * charset.length));
    }

    return autoPassword;
  };

  const getSearchParamsFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const searchText = params.get('searchText') || '';
    const active = params.get('active') || '0';
    const ori = params.get('ori') || '';
    return { searchText, active, ori };
  };

  const { searchText, active, ori } = getSearchParamsFromQuery();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getCompanyLists());
        await dispatch(getEntitle());
        await dispatch(getSite());
        // await dispatch(getEmployees());
        if (id) {
          const entity = {id: id};
          await dispatch(getAEmployee({ id }));
          await dispatch(getEmployeeEdit({ id }));
          await dispatch(getEmployeePhoto({ id }));
          await dispatch(getUserModule(entity));
        } else {
          dispatch(resetForm());
          calculateProrate(employee_category.id, date_joined);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    fetchData();
    setShowProrated(false);
    window.scrollTo(0, 0);
  }, [id]);

  useEffect(() => {
    const hasApproval = employeeModules?.includes("SU-L-APPROVAL");
    const hasBenefit = employeeModules?.includes("SU-M-BENEFIT");
  
    setIsSupervisor(hasApproval && hasBenefit);
  }, [employeeModules]);

  useEffect(() => {
    if (inputValue && inputValue.length > 2) {
      const entity = { searchText: inputValue, active: 1}
      dispatch(postsearchText(entity));
    }
  }, [inputValue]);

  useEffect(() => {
    if (status.description !== "Active" && !date_left) {
      const entity = { ...employee, date_left: moment().format("YYYY-MM-DD") };
      console.log(entity)
      dispatch(updateForm(entity));
    }
  }, [status]);


  useEffect(() => {
    const entity = { ...awardList };
    console.log(entity)
    // dispatch(updateList(entity));

    const dateString = moment(date_joined).format("YYYY-MM-DD");
    const joinDate = new Date(dateString);

    let currentMonth = joinDate.getMonth() + 1;
    if (joinDate.getDate() < 28 && joinDate.getDate() > 12) {
      currentMonth += 0.5;
    } else if (joinDate.getDate() >= 28) {
      currentMonth += 1;
    }

    const diff = (12 - currentMonth) / 12;
    const pct_to_be_prorated = 1.0 - diff;

    const entity_entitle = { ...entitle,
      annual_entitle: Math.round(2 * (diff * entity.annual)) / 2,
      sick_entitle: Math.round(2 * (diff * entity.sick)) / 2,
      medical_entitle: Math.round(2 * (diff * entity.medical)) / 2,
    };
    dispatch(updateEntitle(entity_entitle));

    const newProrated = { ...leaveProrated,
      prorated_pct_first_year: Math.round(1000 * pct_to_be_prorated) / 10,
      // prorated_leave_awarded: Math.round(2 * (diff * entity.annual)) / 2,
      // prorated_sickleave_awarded: Math.round(2 * (diff * entity.sick)) / 2,
      // prorated_medicalbenefit_awarded: Math.round(2 * (diff * entity.medical)) / 2,
      // new_leave_balance: Math.round(2 * (diff * entity.annual)) / 2
      prorated_leave_awarded: (entity.annual - entity_entitle.annual_entitle),
      prorated_sickleave_awarded: (entity.sick - entity_entitle.sick_entitle),
      prorated_medicalbenefit_awarded: (entity.medical - entity_entitle.medical_entitle),
      new_leave_balance: entity_entitle.annual_entitle
    };
    dispatch(updateProrated(newProrated));
    dispatch(updateList(entity));
  }, [annual, sick, medical]);

  useEffect(() => {
    if (summary && summary.length > 0) {
        
      var date = moment(moment(date_left).format());
      var currentMonth = date.month() + 1;
      console.log(currentMonth);
      if (date.date() < 28 && date.date() > 12) {
        currentMonth -= 0.5;  // Add 1 month if before the 13th
      }
      else if (date.date() <= 12) {
        currentMonth -= 1;
      }

      console.log(currentMonth);

      var dateJoined = moment(summary[0]?.employee?.date_joined); // Convert joining date to moment object
      var dateLeft = moment(date_left); // Convert leaving date to moment object

      // Get the year for both joining and leaving
      var yearJoined = dateJoined.year();
      var yearLeft = dateLeft.year();

      var joinMonth = dateJoined.month() - 1;

      // Compare the years
      if (yearJoined === yearLeft) {
        var diff = (currentMonth - joinMonth) / (12 - joinMonth);
        console.log(diff);

      } else {
        var diff = (currentMonth) / 12;
      }

      var prorated_leave_award2 = Math.round(2 * ((summary[0]?.entitled / 12) * (12 - currentMonth)))/2;
      var new_leave_balance2 = +summary[0]?.entitled - +prorated_leave_award2;

      var prorated_sickleave_award = (sickLeaveSummaries[0]?.entitled / 12) * (12 - currentMonth);
      var prorated_medicalbenefit_award = Math.round(2 * ((medicalBenefitSummaries[0]?.entitled / 12) * (12 - currentMonth)))/2;  

      var pct_to_be_prorated = (1.0 - diff);
      var deduction_required2 = 0;

      if (new_leave_balance2 < 0) {
          deduction_required2 = (-1) *  new_leave_balance2;
          new_leave_balance2 = 0;
      };

      const entity = { ...leaveProrated, 
        leave_bf: summary[0]?.ob,
        leave_taken_this_year: summary[0]?.utilized,
        current_leave_balance: Math.round(2 * new_leave_balance2)/2,
        prorate_type: -1,
        // prorate_date: moment(new Date()).format("YYYY-MM-DD"),
        // year: new Date().getFullYear(),
        prorate_date: moment(awarded.effective_date).format("YYYY-MM-DD"),
        year: moment(awarded.effective_date).year(),
        new_leave_balance: Math.round(2 * new_leave_balance2)/2,
        deduction_required: Math.round(2 * deduction_required2)/2,
        // prorated_leave_awarded: Math.round(2 * prorated_leave_award2)/2,
        prorated_leave_awarded: ((Math.round(2 * prorated_leave_award2)/2) * -1),
        prorated_sickleave_awarded: ((Math.round(2 * prorated_sickleave_award)/2) * -1),
        prorated_medicalbenefit_awarded: ((Math.round(2 * prorated_medicalbenefit_award)/2) * -1),
        prorated_pct_final_year: Math.round(1000 * pct_to_be_prorated)/10,
        employee: { id: id }
      }
      console.log(entity);
      dispatch(updateProrated(entity));

      const entity_entitle = { ...entitle,
        annual_entitle: new_leave_balance + Number(sickLeaveSummaries[0]?.ob),
        sick_entitle: Number(sickLeaveSummaries[0]?.entitled) - (Math.abs(prorated_sickleave_awarded)),
        medical_entitle: Number(medicalBenefitSummaries[0]?.entitled) - (Math.abs(prorated_medicalbenefit_awarded))
      };
      console.log(entity_entitle);
      dispatch(updateEntitle(entity_entitle));
    }
  }, [summary, sickLeaveSummaries, medicalBenefitSummaries]);

  const calculateProrate = (categoryId, dateJoined, serviceLengthIdOverride) => {
    // Use explicit service length if provided, then selected, then default "P"
    const serviceLengthId = serviceLengthIdOverride || service_length?.id || "P";
    const leaveValues = getLeaveValues(categoryId, serviceLengthId);
    console.log(leaveValues)
    if (leaveValues) {
      // Input date string
      const dateString = moment(dateJoined).format("YYYY-MM-DD");
      // Create a Date object from the date string
      const date = new Date(dateString);

      // Get the current month (0 = January, so add 1)
      var currentMonth = date.getMonth();

      console.log(currentMonth);

      // Adjust the currentMonth based on the day of the month
      if (date.getDate() < 28 && date.getDate() > 12) {
        currentMonth += 0.5;  // Add 1 month if before the 13th
      }
      else if (date.getDate() >= 28) {
        currentMonth += 1;
      }

      // var diff = (end.getTime() - date.getTime()) / (end.getTime() - start.getTime());
      var diff = (12 - currentMonth) / 12;

      console.log(currentMonth)

      var pct_to_be_prorated = (1.0 - diff);
      var prorated_leave_award2 = (leaveValues.annual / 12) * currentMonth;
      var prorated_sickleave_award = (leaveValues.sick / 12) * currentMonth;
      // var prorated_medicalbenefit_award = (((12 - (date.getMonth()))/12) * leaveValues.medical);

      var prorated_medicalbenefit_award = (leaveValues.medical / 12) * currentMonth;

      // var new_leave_balance2 = +prorated_leave_award2;

      const entity = { ...leaveProrated,
        prorated_pct_first_year: Math.round(1000 * pct_to_be_prorated) / 10,
        prorated_leave_awarded: Math.round(2 * prorated_leave_award2) / 2,
        prorated_sickleave_awarded: Math.round(2 * prorated_sickleave_award) / 2,
        prorated_medicalbenefit_awarded: Math.round(2 * prorated_medicalbenefit_award) / 2,
        new_leave_balance: leaveValues.annual - (Math.round(2 * prorated_leave_award2) / 2)
      }
      dispatch(updateProrated(entity));

      const entityEntitle = { ...entitle,
        annual_entitle: leaveValues.annual - entity.prorated_leave_awarded,
        sick_entitle: leaveValues.sick - entity.prorated_sickleave_awarded,
        medical_entitle: leaveValues.medical - entity.prorated_medicalbenefit_awarded,
      }
      dispatch(updateEntitle(entityEntitle));

      const entity2 = {
        ...awardList,
        annual: leaveValues.annual,
        hospitalization: leaveValues.hospitalization,
        maternity: gender === "F" ? leaveValues.maternity : 0,
        medical: leaveValues.medical,
        sick: leaveValues.sick
      };

      console.log(gender, entity2);
      dispatch(updateList(entity2));
    }
  };

  const handleBtnResetPwd = () => {
    setShowResetPwd(true);
  };

  const handleBtnCancel = () => {
    setShowResetPwd(false);
  };

  const handleBtnSubmit = () => {
    if (showResetPwd) {
      if (newPassword !== repeatNewPassword) {
        Swal.fire("Error", "Passwords do not match", "error");
        setNewPassword("");
        setRepeatNewPassword("");
        return;
      }
      else if (newPassword=== "" || repeatNewPassword==="") {
        Swal.fire("Error", "Please enter a password", "error");
        return;
      }
      else if (newPassword === repeatNewPassword) {
        const entity = { ...user, authentication_type: 1, password: newPassword };
        console.log(entity)
        dispatch(updateUser(entity));
        dispatch(dismissUser({ authentication_type: 1, id: id, password: newPassword }))
          .unwrap()
          .then(() => {
            Swal.fire({
              title: "Password for " + fullname + ' is changed',
              icon: 'success',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                setShowResetPwd(false);
                dispatch(getAEmployee({id}));
                dispatch(getEmployeeEdit({id}));
              }
            });
          })
          .catch((err) => {
            Swal.fire("Error", err.response.data, "error");
          });
      }
    }
  };

  const handleBtnBack = () => {
    dispatch(resetForm());
    // navigate(-1);
    if(searchText && active && !ori){
      navigate(`/EmployeeList?searchText=${searchText}&active=${active}`);
    }
    else if (ori) {
      navigate(`/EmployeeProbationList?searchText=${searchText}&active=${active}`);
    }
    else{
      navigate(-1);
    }
  };

  const handleBtnDismiss = () => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(dismissEmployee({ id: id, status: { id: "-3" }, date_left: moment(new Date()).format("YYYY-MM-DD") }));
        dispatch(dismissUser({ id: id, status: { id: "-1" } }))
          .unwrap()
          .then(() => {
            Swal.fire({
              title: fullname + ' has been dismissed',
              icon: 'success',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                navigate(-1);
              }
            });
          })
          .catch((err) => {
            Swal.fire("Error", err.response.data, "error");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Cancel Dismiss Employee', 'error');
      }
    });
  };

  const handleBtnDelete = () => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
        if (result.isConfirmed) {
          dispatch(dismissEmployee({id: id, status: { id: "-1" }, username: "DELETED"}));
          dispatch(dismissUser({id: id, status: { id: "-1" }, username: "DELETED" }))
            .unwrap()
            .then(() => {
              Swal.fire({
                title: fullname + " has been deleted",
                icon: 'success',
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                  navigate(-1);
                }
              });
            })
            .catch((err) => {
              Swal.fire("Error", err.response.data, "error", "OK");
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Cancel Delete Employee', 'error');
        }
    });
  };

  const handleFormChange = (e) => {
    let { name, value } = e.target;
  
    if (name === "username") {
      // Strip out any non-alphanumeric characters
      value = value.replace(/[^a-zA-Z0-9]/g, "");
    }
  
    const entity = { ...employee, [name]: value };
    console.log(entity)
    dispatch(updateForm(entity));
  
    const entity2 = { ...user, [name]: value };
    console.log(entity2)
    dispatch(updateUser(entity2));
  }; 

  const handleEntitle = (e) => {
    const entity = { ...entitle, [e.target.name]: e.target.value };
    console.log(entity);

    const entity_prorated = { ...leaveProrated,
      prorated_leave_awarded: (annual - entity.annual_entitle),
      prorated_sickleave_awarded: (sick - entity.sick_entitle),
      prorated_medicalbenefit_awarded: (medical - entity.medical_entitle),
      new_leave_balance: entity.annual_entitle
    };
    dispatch(updateEntitle(entity));
    dispatch(updateProrated(entity_prorated));
  };

  const handleProrated = (e) => {
    const entity = { ...leaveProrated, [e.target.name]: e.target.value };
    console.log(entity);

    const entity_entitle = { ...entitle,
      annual_entitle: (annual - entity.prorated_leave_awarded),
      sick_entitle: (sick - entity.prorated_sickleave_awarded),
      medical_entitle: (medical - entity.prorated_medicalbenefit_awarded),
    };
    dispatch(updateEntitle(entity_entitle));
    dispatch(updateProrated(entity));
  };

  const handleLeaveAwards = (e) => {
    const entity = { ...awardList, [e.target.name]: e.target.value };
    dispatch(updateList(entity));
  };

  // Map employee names to options
  const options = employees.map(employee => ({
    label: employee.fullname,
    value: employee.fullname,
    id: employee.id
  }));

  // Find the option that matches the supervisor's fullname
  useEffect(() => {
    if (supervisor && supervisor.id && supervisor.fullname) {
      setSelectedOption({
        value: supervisor.id,
        label: supervisor.fullname,
      });
    }
    // const initialOption = options.find(option => option.id === supervisor?.id);
    // setSelectedOption(initialOption);
  }, [supervisor]);

  useEffect(() => {
    if (gender === "M") {
      const entity = { ...awardList, maternity: 0 };
      console.log(entity)
      dispatch(updateList(entity));
    }
    else {
      const entity = { ...awardList, maternity: 60 };
      console.log(entity)
      dispatch(updateList(entity));
    }
    // const initialOption = options.find(option => option.id === supervisor?.id);
    // setSelectedOption(initialOption);
  }, [gender]);

  const handleDropdownSupervisor = (selectedOption) => {
    setSelectedOption(selectedOption);
    const entity = { ...employee, supervisor: {id:selectedOption.id} };
    console.log(entity)
    dispatch(updateForm(entity));
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    const entity = { ...employee, date_joined: value };
    console.log(entity)
    dispatch(updateForm(entity));
    calculateProrate(employee_category.id, value);
  };

  const handleDateLeftChange = (e) => {
    const value = e.target.value;

    const date = new Date(e.target.value);
    const year = date.getFullYear(); // returns number, e.g., 2025

    // Only proceed if the value has changed
    if (value !== employee.date_left) {
      const entity = { ...employee, date_left: value };
      console.log(entity);

      dispatch(updateForm(entity));
      setShowProrated(true);

      // Chain the dispatches one after another
      dispatch(getLeaveAwardedThisYear({ id, year }))
        .then(() => dispatch(getLeaveSummaryEmployeeYear({ id: id, year })))
        .then(() => dispatch(getSickleaveSummaryEmployeeYear({ id: id, year })))
        .then(() => dispatch(getMedicalbenefitLeaveSummaryEmployeeYear({ id: id, year })))
        .then(() => dispatch(getALeaveProratesByID({ id: id, year: Number(year), type: -1 })))
        .catch((error) => {
          console.error("Error fetching summaries:", error);
        });
    }

    // const entity = { ...employee, date_left: value };
    // console.log(entity)
    // dispatch(updateForm(entity));
    // setShowProrated(true);
    // calculateProrate(employee_category.id, value);
  };

  // Function to get the authentication type label
  const getAuthenticationLabel = (value) => {
    const auth = Authentication.find(auth => auth.value === value);
    return auth ? auth.label : "";
  };

  const handleDropdownAuthentication = (value) => {
    const entity2 = { ...user, authentication_type: value };
    console.log(entity2)
    dispatch(updateUser(entity2));

    if(id) {
      const entity = { ...user, authentication_type: value, password: user.temp_password ?? "" };
      console.log(entity)
      dispatch(updateUser(entity));
      // const entity = { ...user }
      dispatch(dismissUser(entity));
      setPasswordGenerated(false);
    }
    else {
      if (value === 1) {
        const autoPassward = generatePassword();
        const entity = { ...user, authentication_type: value, password: autoPassward };
        console.log(entity)
        dispatch(updateUser(entity));
        setPasswordGenerated(true);
      }
    }
  }
  // Function to get the gender type label
  const getGenderLabel = (value) => {
    const gender = Gender.find(gender => gender.value === value);
    return gender ? gender.label : "";
  };

  const handleDropdownGender = (value) => {
    const entity = { ...employee, gender: value };
    console.log(entity)
    dispatch(updateForm(entity));
  };

  // Function to get the company type label
  const getCompanyLabel = (value) => {
    const company = companyLists.find(company => company.id === value);
    return company ? company.description : "";
  };

  const handleDropdownCompany = (value) => {
    const entity = { ...employee, company: {id: value} };
    dispatch(updateForm(entity));
  };

  // Function to get the site type label
  const getSiteLabel = (value) => {
    const s = siteLists.find(s => s.id === value);
    return s ? s.description : "";
  };

  const handleDropdownSite = (value) => {
    const entity = { ...employee, site: {id: value} };
    dispatch(updateForm(entity));
  };

  // Function to get the WorkingSchedule type label
  const getScheduleLabel = (value) => {
    const schedule = WorkingSchedule.find(schedule => schedule.id === value);
    return schedule ? schedule.value : "";
  };

  const handleDropdownSchedule = (value) => {
    const entity = { ...employee, working_schedule: {id:value} };
    dispatch(updateForm(entity));
  };

  // Function to get the EmployeeCategory type label
  const getEmployeeCategoryLabel = (value) => {
    const category = dynamicCategories.find(category => category.id === value);
    return category ? category.label : "";
  };

  const handleDropdownEmployeeCategory = async (value) => {
    // const entity = { ...employee, employee_category: {id:value} };
    // console.log(entity);
    // dispatch(updateForm(entity));
    
    // // Pass the employee_category: id
    // calculateProrate(value, date_joined);
    if (id){
      try {
        // Reset service length to null or default first valid one
        const allowedLengths = dynamicCategoryServiceMap[value] || [];
        const newServiceLength = allowedLengths.length > 0 ? allowedLengths[0] : null;

        const updatedEmployee = {
          ...employee,
          employee_category: { id: value },
          service_length: { id: newServiceLength },
        };
        console.log(updatedEmployee)
        dispatch(updateForm(updatedEmployee));
        
        // If you need to call calculateProrate or any async function here, do it and await it:
        // await calculateProrate(value, employee.date_joined);

      } catch (err) {
        console.error(err);
      }
    }
    else {
      try {
        const allowedLengths = dynamicCategoryServiceMap[value] || [];
        const newServiceLength = allowedLengths.length > 0 ? allowedLengths[0] : null;

        const updatedEmployee = {
          ...employee,
          employee_category: { id: value },
          service_length: { id: newServiceLength },
        };
        dispatch(updateForm(updatedEmployee));

        calculateProrate(value, date_joined, newServiceLength);
      } catch (err) {
        console.error("Error handling employee category change:", err);
      }
    }
  };

  // Function to get the ServiceLength type label
  const getServiceLengthLabel = (value) => {
    const length = dynamicServiceLengths.find(length => length.id === value);
    return length ? length.label : "";
  };

  const handleDropdownServiceLength = (value) => {
    const entity = { ...employee, service_length: {id:value} };
    dispatch(updateForm(entity));
    calculateProrate(employee_category?.id, date_joined, value);
  };

  const handleBtnUpdateDetails = () => {
    // const entity = { ...user }
    // dispatch(dismissUser(entity));

    if(status?.description!=="Active" && showProrated) {
      const updatedValues = {
        ...proratesList[0],
        prorated_leave_awarded: Math.abs(annual_entitle),
          // prorated_leave_awarded > 0
          //   ? prorated_leave_awarded * -1
          //   : prorated_leave_awarded,
    
        prorated_sickleave_awarded: Math.abs(sick_entitle),
          // prorated_sickleave_awarded > 0
          //   ? prorated_sickleave_awarded * -1
          //   : prorated_sickleave_awarded,
    
        prorated_medicalbenefit_awarded: Math.abs(medical_entitle),
          // prorated_medicalbenefit_awarded > 0
          //   ? prorated_medicalbenefit_awarded * -1
          //   : prorated_medicalbenefit_awarded,
      };
    
      const entity = {
        ...updatedValues,
        prorate_date: moment(awarded.effective_date).format("YYYY-MM-DD"),
      };

      console.log(entity);
    
      dispatch(updateLeaveProrates(entity));
    }

    if (photo.photo !== oldPhotoUrl && photo.photo !== undefined) {
      const entity5 = {
        photo: photo.photo,
        photo_changed: true
      }

      dispatch(replaceEmployeePhoto({id: id, ...entity5})).unwrap();
    }

    setLoading3(true); // Start loading

    dispatch(dismissEmployee({ id: id, ...employee, date_joined: moment(date_joined).format("YYYY-MM-DD") }))
      .unwrap()
      .then(() => {
        return dispatch(updateUserAccessModules({
          employee: { id },
          modules: employeeModules
        })).unwrap();
      })
      .then(() => {
        setLoading3(false);
        return Swal.fire({
          title: fullname + ' record is updated.',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      })
      .then(() => {
        if(searchText && active){
          navigate(`/EmployeeList?searchText=${searchText}&active=${active}`);
        }
        else{
          navigate(-1);
        }
        // navigate(`/EmployeeList?searchText=${searchText}&active=${active}`);
      })
      .catch((err) => {
        Swal.fire("Error", err.response?.data || "An error occurred", "error");
      });    
  };

  const handleResign = (id) => {
    const isSupervisor = employeeModules.includes("SU-L-APPROVAL") || employeeModules.includes("SU-M-BENEFIT");
    navigate(`/EmployeeResignationForm/${id}?isSupervisor=${isSupervisor}`);
    // navigate(`/EmployeeResignationForm/${id}`);
  };

  const handleBtnAdd = async () => {
    
    const entity = { ...user };

    console.log(entity);

    let missingFields = [];

    if (fullname === "") missingFields.push("Fullname");
    if (username === "") missingFields.push("Username");
    if (sid === "") missingFields.push("Staff ID");
    // if (email === "") missingFields.push("Email");
    // if (supervisor.id === "") missingFields.push("Supervisor");

    if (missingFields.length > 0) {
      Swal.fire({
        title: "Missing Required Fields",
        text: `Please fill in the following: ${missingFields.join(", ")}`,
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }

    try {
      // Check if the username exists by dispatching addUsername
      await dispatch(addUsername(entity)).unwrap();
      
      // If addUsername succeeds, proceed with user creation
      const addedUser = await dispatch(addUser(entity)).unwrap();
      const userId = addedUser.id;

      const entity2 = { 
        ...employee, 
        id: userId, 
        date_joined: moment(date_joined).format("YYYY-MM-DD") 
      };

      const entity3 = { 
        ...awardList, 
        advanced: "5", 
        employee: { 
          id: userId,
          service_length: {
            id: service_length?.id
          } 
        },
        // effective_date: moment(date_joined).format("YYYY-MM-DD"), 
        effective_date: moment(date_joined).year() !== moment().year() ? `${moment().year()}-01-01` : moment(date_joined).format("YYYY-MM-DD"),
        leave_award_type: { id: "A" }, 
        employee_category: { id: employee_category.id },
        service_length: 0,
        service_length2: service_length?.id, 
        year: `${moment().year()}`
      };

      const entity4 = { 
        ...leaveProrated, 
        employee: { id: userId }, 
        current_leave_balance: annual_entitle,
        leave_awarded_this_year: annual, 
        medicalbenefit_awarded_for_this_year: medical, 
        new_leave_balance: annual_entitle, 
        prorate_date: moment(date_joined).format("YYYY-MM-DD"), 
        sickleave_awarded_for_this_year: sick, 
        prorated_leave_awarded: Math.abs(annual_entitle),
        prorated_sickleave_awarded: Math.abs(sick_entitle),
        prorated_medicalbenefit_awarded: Math.abs(medical_entitle),
        // prorated_leave_awarded: prorated_leave_awarded > 0 ? prorated_leave_awarded * -1 : prorated_leave_awarded,
        // prorated_sickleave_awarded: prorated_sickleave_awarded > 0 ? prorated_sickleave_awarded * -1 : prorated_sickleave_awarded,
        // prorated_medicalbenefit_awarded: prorated_medicalbenefit_awarded > 0 ? prorated_medicalbenefit_awarded * -1 : prorated_medicalbenefit_awarded,
        year: moment(date_joined).format("YYYY") 
      };
  
      // Dispatch remaining actions with the new user ID
      // await Promise.all([
      //   dispatch(addEmployee(entity2)).unwrap(),
      //   dispatch(addLeaveAwards(entity3)).unwrap(),
      //   dispatch(addLeaveProrated(entity4)).unwrap()
      // ]);

      // Dispatch addEmployee first
      await dispatch(addEmployee(entity2)).unwrap();

      // Run addLeaveAwards and after that completes, run addLeaveProrated
      await dispatch(addLeaveAwards(entity3)).unwrap();

      // Dispatch uploadEmployeePhoto action if needed
      // This condition ensures it's only dispatched if a photo was uploaded
      if (photo && photo.photo) {
        const entity5 = {
          photo: photo.photo,
          employee: { id: userId }
        };

        await dispatch(uploadEmployeePhoto({ id: userId, ...entity5 })).unwrap();
      }

      if (moment(date_joined).year() === moment().year()) {
        await dispatch(addLeaveProrated(entity4)).unwrap();
      }

      if (isSupervisor) {
        const supervisor = {
          employee: { id: userId },
          modules: ["SU-L-APPROVAL", "SU-M-BENEFIT"]
        };
        await dispatch(updateUserAccessModules(supervisor)).unwrap();
      }
      
      dispatch(resetForm());
      Swal.fire({
        title: `${fullname} is added.`,
        icon: 'success',
        showCancelButton: true,
        confirmButtonText: 'Add Another Record',
        cancelButtonText: 'Back to Employee List',
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(resetForm());
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          // User chose "Back to List"
          navigate(`/EmployeeList`);
        }
      });
      
    } catch (err) {
      Swal.fire("Error", err.response?.data || err.message, "error");
    }
  };

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    setOriginalPhoto(file);
    
    const editor = await openEditor({ src: e.target.files[0] });
    // Store the old photo URL
    oldPhotoUrl = photo?.photo;
    // Update the photo URL with the new one
    const entity = { ...photo, photo: editor?.editedImage?.getDataURL() };
    console.log(entity);
    dispatch(updatePhoto(entity));
    setShowUploadButton(false);
  };

  const handleImageClick = async () => {
    if (!photo?.photo || photo.photo === defaultPhoto || originalPhoto === null) {
      // No photo uploaded yet → trigger upload
      setShowUploadButton(true);
    } else {
      // Photo exists → show option dialog
      setShowOptionDialog(true);
    }
  };

  const handleBtnCancelImage = () => {
    setShowUploadButton(false);
  };

  const handleEditImage = async () => {
    setShowOptionDialog(false);
    const editor = await openEditor({ src: originalPhoto });
    const entity = { ...photo, photo: editor?.editedImage?.getDataURL() };
    dispatch(updatePhoto(entity));
  };
  
  const handleUploadNew = () => {
    setShowOptionDialog(false);
    setShowUploadButton(true);
  };

  const handleChangeLeaveProrated = (e) => {
    const entity = { ...leaveProrated, [e.target.name]: e.target.value };

    var date = moment(moment(date_left).format());
    var currentMonth = date.month() + 1;
    console.log(currentMonth);

    // Adjust the currentMonth based on the day of the month
    if (date.date() < 28 && date.date() > 12) {
      currentMonth -= 0.5;  // Add 1 month if before the 13th
    }
    else if (date.date() <= 12) {
      currentMonth -= 1;
    }

    var dateJoined = moment(date_joined); // Convert joining date to moment object
    var dateLeft = moment(date_left); // Convert leaving date to moment object

    // Get the year for both joining and leaving
    var yearJoined = dateJoined.year();
    var yearLeft = dateLeft.year();

    //Join Month
    var joinMonth = dateJoined.month() - 1;

    // Compare the years
    if (yearJoined === yearLeft) {
      // var joinMonth = dateJoined.month() + 1;
      var diff = (currentMonth - joinMonth) / (12 - joinMonth);
    } else {
      var diff = (currentMonth) / 12;
    }

    let pct_to_be_prorated = 1.0 - diff;
    var prorated_leave_award2 = entity.prorated_leave_awarded;
    // var new_leave_balance2 = +summary[0]?.cf - +prorated_leave_award2;
    var balance = Number(summary[0]?.utilized);
    var new_leave_balance2 = (Number(summary[0]?.entitled) - balance - Math.abs(prorated_leave_award2) + Number(summary[0]?.ob));
    let deduction_required2 = 0;

    var sick = Number(sickLeaveSummaries[0]?.entitled) - (Number(sickLeaveSummaries[0]?.utilized)) - Math.abs(entity.prorated_sickleave_awarded);
    var medical = Number(medicalBenefitSummaries[0]?.entitled) - (Number(medicalBenefitSummaries[0]?.utilized)) - Math.abs(entity.prorated_medicalbenefit_awarded);
    // if (new_leave_balance2 < 0) {
    //   deduction_required2 = (-1) *  new_leave_balance2;
    //   new_leave_balance2 = 0;
    // }

    entity.new_leave_balance = Math.round(new_leave_balance2 * 2) / 2;
    entity.deduction_required = Math.round(deduction_required2 * 2) / 2;
    entity.prorated_leave_awarded = ((Math.round(2 * entity.prorated_leave_awarded)/2) * -1);
    entity.prorated_pct_final_year = Math.round(pct_to_be_prorated * 1000) / 10;

    console.log(entity);
    dispatch(updateProrated(entity));

    const entity_entitle = { ...entitle,
      annual_entitle: entity.new_leave_balance,
      sick_entitle: sick,
      medical_entitle: medical,
    };
    console.log(entity);
    dispatch(updateEntitle(entity_entitle));
  };

  const handleChangeLeaveBalance = (e) => {
    const entity = { ...entitle, [e.target.name]: e.target.value };

    var annual_prorated = Number(summary[0]?.entitled) - Number(summary[0]?.utilized) - Number(entity.annual_entitle) + Number(summary[0]?.ob);

    const entity_prorated = { ...leaveProrated,
      prorated_leave_awarded: annual_prorated,
      prorated_sickleave_awarded: Number(sickLeaveSummaries[0]?.entitled) - Number(sickLeaveSummaries[0]?.utilized) - Number(entity.sick_entitle),
      prorated_medicalbenefit_awarded: Number(medicalBenefitSummaries[0]?.entitled) - Number(medicalBenefitSummaries[0]?.utilized) - Number(entity.medical_entitle),
      new_leave_balance: annual_prorated,
    };
    console.log(entity_prorated);
    dispatch(updateProrated(entity_prorated));

    console.log(entity);
    dispatch(updateEntitle(entity));
  };

  const handleBtnAccessAccount = (e) => {
    console.log(id);
    const entity = { id: id, fullname: fullname };

    if (localStorage.getItem("ori_current_user")) {
      localStorage.setItem("current_user", JSON.stringify(entity));
      localStorage.setItem("roles", JSON.stringify(employeeModules));
      localStorage.setItem("token", user?.token);
      localStorage.setItem("user", JSON.stringify(user));
    }
    else {
      localStorage.setItem("ori_current_user", localStorage.getItem("current_user"));
      localStorage.setItem("ori_roles", localStorage.getItem("roles"));
      localStorage.setItem("ori_token", localStorage.getItem("token"));
      localStorage.setItem("ori_user", localStorage.getItem("user"));
      localStorage.setItem("ori_leaveData", localStorage.getItem("leaveData"));
      
      localStorage.removeItem("current_user");
      localStorage.removeItem("roles");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("leaveData");
      
      localStorage.setItem("current_user", JSON.stringify(entity));
      localStorage.setItem("roles", JSON.stringify(employeeModules));
      localStorage.setItem("token", user?.token);
      localStorage.setItem("user", JSON.stringify(user));
    }
    navigate('/');
  }; 

  return (
    <Container className="ContainerContent">
      {(loading || loading2 || loading3) && (
          <ThreeDots
          visible={true}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
              position: 'fixed',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: '9999',
          }}
          />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        <h1 className="TitleHeader">Employees</h1>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Row className="my-3 relative-container">
              <img
                src={photo?.photo || defaultPhoto}
                alt="Employee Photo"
                className="oval-image"
                onClick={handleImageClick}
                style={{ cursor: "pointer" }}
              />
              {showUploadButton && (
                <Form className="upload-button-style">
                  <Form.Group  controlId="formFile" className="mt-3">
                    <Form.Control type="file" accept="image/*" onChange={handlePhotoChange} />
                    <br/>
                    <Button className="Button" onClick={handleBtnCancelImage}>Cancel</Button>
                  </Form.Group>
                </Form>
              )}

              {showOptionDialog && (
                <Form className="upload-button-style">
                  <Form.Group className="mt-3">
                    <div className="d-flex flex-column gap-2">
                      <Button variant="primary" onClick={handleEditImage}>
                        Edit Current Photo
                      </Button>
                      <Button variant="secondary" onClick={handleUploadNew}>
                        Upload New Photo
                      </Button>
                      <Button variant="outline-danger" onClick={() => setShowOptionDialog(false)}>
                        Cancel
                      </Button>
                    </div>
                  </Form.Group>
                </Form>
              )}
            </Row>
            
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Fullname</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="fullname" value={fullname || ""} placeholder="Fullname" onChange={handleFormChange}/>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Username</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="username" value={username || ""} placeholder="Username" onChange={handleFormChange} disabled={!!id}/>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Staff ID</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="sid" value={sid || ""} placeholder="Staff ID" onChange={handleFormChange}/>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Email</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="email" value={email || ""} placeholder="Email" onChange={handleFormChange}/>
              </Col>
            </Row>
            
            {(!isIdInHR || (isIdInHR && isCurrentUserInHR)) && (
              <Row className="my-3">
                <Col md={4} sm={4}>
                  <Form.Label className="FormLabel fw-normal fs-5">
                    Authentication Type
                  </Form.Label>
                </Col>
                <Col md={8} sm={8}>
                  <Dropdown>
                    <Dropdown.Toggle className="Button" style={{width: "100%"}}>{getAuthenticationLabel(authentication_type)}</Dropdown.Toggle>
                    <Dropdown.Menu style={{width: "100%"}}>
                      {Authentication.map((action, index) => (
                        <Dropdown.Item key={index} onClick={() => handleDropdownAuthentication(action.value)}>
                          {action.label}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
              </Row>
            )}
            {passwordGenerated == true && !id && authentication_type == 1 && (
              <Row className="my-3">
                <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Password</Form.Label>
                </Col>
                <Col md={8} sm={8}>
                  <Form.Control name="password" value={password} onChange={handleFormChange}/>
                </Col>
              </Row>
            )}

            {/* login as that user */}
            {impersonate_role && id && (
              <Row className="my-3">
                <Col md={4} sm={4}>
                {/* <Form.Label className="FormLabel fw-normal fs-5">Password</Form.Label> */}
                </Col>
                <Col md={8} sm={8}>
                  <Button className="Button w-100" onClick={handleBtnAccessAccount}>
                    IMPERSONATE
                  </Button>
                </Col>
              </Row>
            )}

            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">
                  Gender
                </Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Dropdown>
                  <Dropdown.Toggle className="Button" style={{width: "100%"}}>{getGenderLabel(gender) || "MALE"}</Dropdown.Toggle>
                  <Dropdown.Menu style={{width: "100%"}}>
                    {Gender.map((action, index) => (
                      <Dropdown.Item key={index} onClick={() => handleDropdownGender(action.value)}>
                        {action.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">
                  Role
                </Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Check 
                  type="checkbox"
                  label="Supervisor"
                  checked={isSupervisor}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setIsSupervisor(checked);

                    const supervisorModules = ["SU-L-APPROVAL", "SU-M-BENEFIT"];
                    const currentModules = [...employeeModules];

                    let updatedModules;

                    if (checked) {
                      // Add supervisor modules if not already present
                      updatedModules = Array.from(new Set([...currentModules, ...supervisorModules]));
                    } else {
                      // Remove only the supervisor modules
                      updatedModules = currentModules.filter(
                        (mod) => !supervisorModules.includes(mod)
                      );
                    }

                    dispatch(updateEmployeeModules(updatedModules));
                  }}
                  style={{ color: 'white' }}
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">
                  Status
                </Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={status?.description || "Pending"} readOnly disabled/>
              </Col>
            </Row>
          </Col>

          <Col md={6} sm={6}>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Company</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Dropdown>
                <Dropdown.Toggle className="Button" style={{width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                    {getCompanyLabel(company?.id).toUpperCase() || "4140add6-22b3-1324-05bc-9000ec3039e2"}
                </Dropdown.Toggle>
                  <Dropdown.Menu style={{ width: "100%", maxHeight: "250px", overflowY: "auto", }} >
                    {companyLists.map((company, index) => (
                      <Dropdown.Item
                        key={index}
                        onClick={() => handleDropdownCompany(company.id)}
                      >
                        {company.description.toUpperCase()}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Site</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Dropdown>
                  <Dropdown.Toggle className="Button" style={{width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                    {getSiteLabel(site?.id)?.toUpperCase() || "Select Site"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ width: "100%", maxHeight: "250px", overflowY: "auto" }}>
                    {siteLists.map((s, index) => (
                      <Dropdown.Item
                        key={index}
                        onClick={() => handleDropdownSite(s.id)}
                      >
                        {s.description.toUpperCase()}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Working Schedule</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Dropdown>
                  <Dropdown.Toggle className="Button" style={{width: "100%"}}>{getScheduleLabel(working_schedule?.id).toUpperCase() || "S"}</Dropdown.Toggle>
                  <Dropdown.Menu style={{width: "100%"}}>
                    {WorkingSchedule.map((action, index) => (
                      <Dropdown.Item key={index} onClick={() => handleDropdownSchedule(action.id)}>
                        {action.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Employee Category</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                {/* <Dropdown>
                  <Dropdown.Toggle className="Button" style={{width: "100%"}}>{getEmployeeCategoryLabel(employee_category?.id) || "S"}</Dropdown.Toggle>
                  <Dropdown.Menu style={{width: "100%"}}>
                    {EmployeeCategory.map((action, index) => (
                      <Dropdown.Item key={index} onClick={() => handleDropdownEmployeeCategory(action.id)}>
                        {action.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown> */}
                <Dropdown>
                  <Dropdown.Toggle className="Button" style={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {getEmployeeCategoryLabel(employee_category?.id) || "S"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ width: "100%" }}>
                    {dynamicCategories.map((action) => (
                      <Dropdown.Item key={action.id} onClick={() => handleDropdownEmployeeCategory(action.id)}>
                        {action.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>

            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Service Length</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                {/* <Dropdown>
                  <Dropdown.Toggle className="Button" style={{width: "100%"}}>{getServiceLengthLabel(service_length?.id).toUpperCase() || "UK"}</Dropdown.Toggle>
                  <Dropdown.Menu style={{width: "100%"}}>
                    {ServiceLength.map((action, index) => (
                      <Dropdown.Item key={index} onClick={() => handleDropdownServiceLength(action.id)}>
                        {action.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown> */}
                <Dropdown>
                  <Dropdown.Toggle className="Button" style={{ width: "100%" }}>
                    {getServiceLengthLabel(service_length?.id)?.toUpperCase() || "UK"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ width: "100%" }}>
                    {filteredServiceLengths.map((action) => (
                      <Dropdown.Item key={action.id} onClick={() => handleDropdownServiceLength(action.id)}>
                        {action.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>

            {id ? (
              <>
              <Row className="my-3">
                <Col md={4} sm={4}>
                  <Form.Label className="FormLabel fw-normal fs-5">Date Join</Form.Label>
                </Col>
                <Col md={8} sm={8}>
                  <DatePicker
                    selected={date_joined ? new Date(date_joined) : null}
                    onChange={(date) =>
                      handleDateChange({
                        target: {
                          name: "date_joined",
                          value: moment(date).format("YYYY-MM-DD"),
                        },
                      })
                    }
                    dateFormat="yyyy-MM-dd"
                    className="form-control w-100 datepicker-icon"
                  />
                </Col>
              </Row>
              </>
            ) : (
              <>
              <hr/>
              <Row className="my-3">
                <Col md={4} sm={4}>
                  <Form.Label className="FormLabel fw-normal fs-5">Date Join</Form.Label>
                </Col>
                <Col md={8} sm={8}>
                  <DatePicker
                    selected={date_joined ? new Date(date_joined) : null}
                    onChange={(date) =>
                      handleDateChange({
                        target: {
                          name: "date_joined",
                          value: moment(date).format("YYYY-MM-DD"),
                        },
                      })
                    }
                    dateFormat="yyyy-MM-dd"
                    className="form-control w-100 datepicker-icon"
                  />
                </Col>
              </Row>

              <Row className="my-3">
                <Col md={4} sm={1}></Col>

                <Col md={8}>
                  <div className="d-flex gap-3">
                    <Form.Label className="FormLabel fw-normal fs-5 flex-fill text-center" style={{marginLeft: '-5px'}}>Awarded</Form.Label>
                    <Form.Label className="FormLabel fw-normal fs-5 flex-fill text-center" style={{marginLeft: '-10px'}}>Prorated</Form.Label>
                    <Form.Label className="FormLabel fw-normal fs-5 flex-fill text-center" style={{marginLeft: '-10px'}}>Entitled</Form.Label>
                  </div>
                </Col>
              </Row>

              <Row className="my-3 align-items-center">
                <Col md={4}>
                  <Form.Label className="FormLabel fw-normal fs-5">Annual Leave</Form.Label>
                </Col>

                <Col md={8}>
                  <div className="d-flex gap-3">
                    <Form.Control
                      type="number"
                      name="annual"
                      value={Math.abs(annual).toFixed(1)}
                      // value={annual}
                      onChange={handleLeaveAwards}
                      className="fs-6 flex-fill text-center"
                    />
                    <Form.Control
                      type="number"
                      name="prorated_leave_awarded"
                      value={Math.abs(prorated_leave_awarded).toFixed(1)}
                      // value={prorated_leave_awarded}
                      onChange={handleProrated}
                      className="fs-6 flex-fill text-center"
                    />
                    <Form.Control
                      type="number"
                      name="annual_entitle"
                      value={Math.abs(annual_entitle).toFixed(1)}
                      // value={annual_entitle}
                      onChange={handleEntitle}
                      className="fs-6 flex-fill text-center"
                    />
                  </div>
                </Col>
              </Row>

              <Row className="my-3">
                <Col md={4} sm={4}>
                  <Form.Label className="FormLabel fw-normal fs-5">Sick Leave</Form.Label>
                </Col>
                <Col md={8}>
                  <div className="d-flex gap-3">
                    <Form.Control
                      type="number"
                      name="sick"
                      value={Math.abs(sick).toFixed(1)}
                      // value={sick}
                      onChange={handleLeaveAwards}
                      className="fs-6 flex-fill text-center"
                    />
                    <Form.Control
                      type="number"
                      name="prorated_sickleave_awarded"
                      value={Math.abs(prorated_sickleave_awarded).toFixed(1)}
                      // value={prorated_sickleave_awarded}
                      onChange={handleProrated}
                      className="fs-6 flex-fill text-center"
                    />
                    <Form.Control
                      type="number"
                      name="sick_entitle"
                      value={Math.abs(sick_entitle).toFixed(1)}
                      // value={sick_entitle}
                      onChange={handleEntitle}
                      className="fs-6 flex-fill text-center"
                    />
                  </div>
                </Col>
                {/* <Col md={4} sm={1}>
                  <Form.Control name="sick" value={sick} onChange={handleLeaveAwards}/>
                </Col>
                <Col md={4} sm={6}>
                  <Form.Control name="prorated_sickleave_awarded" value={prorated_sickleave_awarded} onChange={handleProrated}/>
                </Col> */}
              </Row>

              <Row className="my-3">
                <Col md={4} sm={4}>
                  <Form.Label className="FormLabel fw-normal fs-5">Medical Claim</Form.Label>
                </Col>
                <Col md={8}>
                  <div className="d-flex gap-3">
                    <Form.Control
                      type="number"
                      name="medical"
                      value={Math.abs(medical).toFixed(1)}
                      // value={medical}
                      onChange={handleLeaveAwards}
                      className="fs-6 flex-fill text-center"
                    />
                    <Form.Control
                      type="number"
                      name="prorated_medicalbenefit_awarded"
                      value={Math.abs(prorated_medicalbenefit_awarded).toFixed(1)}
                      // value={prorated_medicalbenefit_awarded}
                      onChange={handleProrated}
                      className="fs-6 flex-fill text-center"
                    />
                    <Form.Control
                      type="number"
                      name="medical_entitle"
                      value={Math.abs(medical_entitle).toFixed(1)}
                      // value={medical_entitle}
                      onChange={handleEntitle}
                      className="fs-6 flex-fill text-center"
                    />
                  </div>
                </Col>
                {/* <Col md={4} sm={1}>
                  <Form.Control name="medical" value={medical} onChange={handleLeaveAwards}/>
                </Col>
                <Col md={4} sm={6}>
                  <Form.Control name="prorated_medicalbenefit_awarded" value={prorated_medicalbenefit_awarded} onChange={handleProrated}/>
                </Col> */}
              </Row>

              {/* <Row className="my-3">
                <Col md={4} sm={4}>
                  <Form.Label className="FormLabel fw-normal fs-5">Hospitalization Leave</Form.Label>
                </Col>
                <Col md={8} sm={8}>
                  <Form.Control name="hospitalization" value={hospitalization} onChange={handleLeaveAwards}/>
                </Col>
              </Row> */}

              {gender === "F" && (
                <Row className="my-3">
                  <Col md={4} sm={4}>
                    <Form.Label className="FormLabel fw-normal fs-5">Maternity Leave</Form.Label>
                  </Col>
                  <Col md={8} sm={8}>
                    <Form.Control name="maternity" value={Math.abs(maternity).toFixed(1)} readOnly disabled/>
                  </Col>
                </Row>
              )}
              </>
            )}

            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Supervisor</Form.Label>
              </Col>
              <Col md={8} sm={8}>
              <Select
                inputValue={inputValue}
                onInputChange={(value) => setInputValue(value)}
                name="supervisor"
                onChange={handleDropdownSupervisor}
                options={options}
                value={selectedOption}
                placeholder="Select Supervisor"
              />
              </Col>
            </Row>

            {id && status?.description!=="Active" && (
              <Row className="my-3">
                <Col md={4} sm={4}>
                  <Form.Label className="FormLabel fw-normal fs-5">
                    Date Left
                  </Form.Label>
                </Col>
                <Col md={8} sm={8}>
                  {/* <Form.Control value={moment(date_left).format("YYYY-MM-DD")} readOnly /> */}
                  <DatePicker
                    selected={date_left ? new Date(date_left) : null}
                    onChange={(date) =>
                      handleDateLeftChange({
                        target: {
                          name: "date_left",
                          value: moment(date).format("YYYY-MM-DD"),
                        },
                      })
                    }
                    dateFormat="yyyy-MM-dd"
                    className="form-control w-100 datepicker-icon"
                  />
                </Col>
              </Row>
            )}

            {showProrated && (
              <>
              <hr></hr>
              {/* <Row className="my-3">
                <Col md={4} sm={4}>
                  <Form.Label className="FormLabel fw-normal">Leave Brought Forward</Form.Label>
                </Col>
                <Col md={8} sm={8}>
                  <Form.Control name="leave_bf" value={leave_bf} readOnly disabled/>
                </Col>
              </Row> */}
              <Row className="my-3">
                <Col md={4} sm={1}></Col>

                <Col md={8}>
                  <div className="d-flex gap-3">
                    <Form.Label className="FormLabel fw-normal fs-6 flex-fill text-center" style={{marginLeft: '-7px'}}>Awarded</Form.Label>
                    {/* <Form.Label className="FormLabel fw-normal fs-6 flex-fill text-center" style={{marginLeft: '-8px'}}>Utilized</Form.Label> */}
                    {/* <Form.Label className="FormLabel fw-normal fs-6 flex-fill text-center" style={{marginLeft: '-10px'}}>Prorated</Form.Label> */}
                    <Form.Label className="FormLabel fw-normal fs-6 flex-fill text-center" style={{marginLeft: '-10px'}}>Entitled</Form.Label>
                  </div>
                </Col>
              </Row>

              <Row className="my-3 align-items-center">
                <Col md={4}>
                  <Form.Label className="FormLabel fw-normal fs-6">Annual Leave</Form.Label>
                </Col>

                <Col md={8}>
                  <div className="d-flex gap-3">
                    <Form.Control
                      value={summary[0]?.entitled}
                      className="fs-6 flex-fill text-center"
                      readOnly
                      disabled
                    />
                    {/* <Form.Control
                      value={Math.abs(Number(summary[0]?.utilized)).toFixed(1)}
                      className="fs-6 flex-fill text-center"
                      readOnly
                      disabled
                    />
                    <Form.Control
                      type="number"
                      name="prorated_leave_awarded"
                      value={Math.abs(prorated_leave_awarded).toFixed(1)}
                      onChange={handleChangeLeaveProrated}
                      className="fs-6 flex-fill text-center"
                    /> */}
                    <Form.Control
                      type="number"
                      name="annual_entitle"
                      value={Number(annual_entitle).toFixed(1)}
                      onChange={handleChangeLeaveBalance}
                      className="fs-6 flex-fill text-center"
                    />
                  </div>
                </Col>
              </Row>

              <Row className="my-3 align-items-center">
                <Col md={4}>
                  <Form.Label className="FormLabel fw-normal fs-6">Sick Leave</Form.Label>
                </Col>

                <Col md={8}>
                  <div className="d-flex gap-3">
                    <Form.Control
                      value={sickLeaveSummaries[0]?.entitled}
                      className="fs-6 flex-fill text-center"
                      readOnly
                      disabled
                    />
                    {/* <Form.Control
                      value={Math.abs(Number(sickLeaveSummaries[0]?.utilized)).toFixed(1)}
                      className="fs-6 flex-fill text-center"
                      readOnly
                      disabled
                    />
                    <Form.Control
                      type="number"
                      name="prorated_sickleave_awarded"
                      value={Math.abs(prorated_sickleave_awarded).toFixed(1)}
                      onChange={handleChangeLeaveProrated}
                      className="fs-6 flex-fill text-center"
                    /> */}
                    <Form.Control
                      type="number"
                      name="sick_entitle"
                      value={Number(sick_entitle).toFixed(1)}
                      onChange={handleChangeLeaveBalance}
                      className="fs-6 flex-fill text-center"
                    />
                  </div>
                </Col>
              </Row>

              <Row className="my-3 align-items-center">
                <Col md={4}>
                  <Form.Label className="FormLabel fw-normal fs-6">Medical Claim</Form.Label>
                </Col>

                <Col md={8}>
                  <div className="d-flex gap-3">
                    <Form.Control
                      value={Math.abs(medicalBenefitSummaries[0]?.entitled).toFixed(1)}
                      className="fs-6 flex-fill text-center"
                      readOnly
                      disabled
                    />
                    {/* <Form.Control
                      value={Math.abs(Number(medicalBenefitSummaries[0]?.utilized)).toFixed(1)}
                      className="fs-6 flex-fill text-center"
                      readOnly
                      disabled
                    />
                    <Form.Control
                      type="number"
                      name="prorated_medicalbenefit_awarded"
                      value={Math.abs(prorated_medicalbenefit_awarded).toFixed(1)}
                      onChange={handleChangeLeaveProrated}
                      className="fs-6 flex-fill text-center"
                    /> */}
                    <Form.Control
                      type="number"
                      name="medical_entitle"
                      value={Number(medical_entitle).toFixed(1)}
                      onChange={handleChangeLeaveBalance}
                      className="fs-6 flex-fill text-center"
                    />
                  </div>
                </Col>
              </Row>

              <Row className="my-3">
                <p style={{ color: 'yellow', fontSize: '1.1rem' }}>
                  Entitled = Leave balance after deductions (e.g. Leave Awarded - Leave Deductions)
                </p>
              </Row>
              </>
            )}
          </Col>
        </Row>

        {showResetPwd == true && (
          <>
          <Card style={{ backgroundColor: "gray", marginBottom: "20px" }}>
            <Row className="my-3 mx-3">
              <Col md={6} sm={6}>
                <Form.Label className="FormLabel fw-normal fs-5">New Password</Form.Label>
              </Col>
              <Col md={6} sm={6}>
                <Form.Control 
                  type="password" 
                  value={newPassword} 
                  onChange={(e) => setNewPassword(e.target.value)} 
                />
              </Col>
            </Row>
            <Row className="my-3 mx-3">
              <Col md={6} sm={6}>
                <Form.Label className="FormLabel fw-normal fs-5">
                  Repeat New Password
                </Form.Label>
              </Col>
              <Col md={6} sm={6}>
                <Form.Control 
                  type="password" 
                  value={repeatNewPassword} 
                  onChange={(e) => setRepeatNewPassword(e.target.value)} 
                />
              </Col>
            </Row>
            <div className="d-flex justify-content-between my-3 mx-3">
              <ButtonGroup style={{ marginLeft: "auto" }}>
                <Button className="Button" onClick={handleBtnCancel}>
                  Cancel
                </Button>
                &nbsp;&nbsp;
                <Button className="Button" onClick={handleBtnSubmit}>
                  Update
                </Button>
              </ButtonGroup>
            </div>
          </Card>
          <br/>
          </>
        )}

        {!id ? (
        <div className="d-flex flex-column flex-md-row justify-content-between my-3 gap-2">
          <ButtonGroup>
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          <ButtonGroup>
            <Button className="Button" onClick={handleBtnAdd}>
              Submit
            </Button>
          </ButtonGroup>
        </div>
        ) : (
        <>
        <div className="d-flex flex-column flex-md-row justify-content-between my-3 gap-2">
          <ButtonGroup>
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>

          <ButtonGroup className="d-flex flex-wrap gap-2">
            <Button className="Button" onClick={handleBtnDelete}>
              Delete
            </Button>

            {status?.description!=="Active" ? (
              <Button className="Button" disabled>
                Resign
              </Button>
            ):(
              <Button className="Button" onClick={() => handleResign(employee.id)}>
                Resign
              </Button>
            )}

            <Button className="Button" onClick={handleBtnDismiss}>
              Dismiss
            </Button>
            {
              id &&
              authentication_type===1 &&
              (
                !isIdInHR || (isIdInHR && isCurrentUserInHR)
              ) && (
              <>
              <Button className="Button" onClick={handleBtnResetPwd}>
                Reset Password
              </Button>
              </>
            )}

            <Button className="Button" onClick={handleBtnUpdateDetails}>
              Update
            </Button>
          </ButtonGroup>
        </div>
        </>
        )}
      </Card>
    </Container>
  );
};
export default EmployeeForm;